import { GetCardActivationInfoResponse } from "../../../lib/api/models";
import styles from "./CardActivationInfo.module.css";

const strings = {
  activated: "Activated:",
  yes: "Yes",
  no: "No",
  timeAccountOpen: "Time Account Open:",
  greaterThanSixMonths: "Greater than 6 months",
  lessThanSixMonths: "Less than 6 months",
  ssn: "SSN:",
  ssnMasked: (last4: string) => `xxx-xx-${last4}`,
  dob: "DOB:",
};

type Props = {
  cardActivationInfo: GetCardActivationInfoResponse;
};

export default function CardActivationInfo({ cardActivationInfo }: Props) {
  return (
    <div>
      <h3 className={styles.header}>
        {(cardActivationInfo.activated
          ? cardActivationInfo.activatedPageTitle
          : cardActivationInfo.pageTitle
        )
          // Replace all ≥, >, ≤, and < to ensure proper display
          .replaceAll("<u>gt;</u>", "\u2265")
          .replaceAll("&gt;", "\u003e")
          .replaceAll("<u>&lt;</u>", "\u2264")
          .replaceAll("&lt;", "\u003c")}
      </h3>
      {cardActivationInfo.showFields && (
        <div>
          <div className={styles.row}>
            <div className={styles.label}>{strings.activated}</div>
            <div className={styles.value}>
              {cardActivationInfo.activated ? strings.yes : strings.no}
            </div>
          </div>
          <div className={styles.divider} />
          <div className={styles.row}>
            <div className={styles.label}>{strings.timeAccountOpen}</div>
            <div className={styles.value}>
              {cardActivationInfo.accountOpenLongerThanSixMonths
                ? strings.greaterThanSixMonths
                : strings.lessThanSixMonths}
            </div>
          </div>
          <div className={styles.divider} />
          <div className={styles.row}>
            <div className={styles.label}>{strings.ssn}</div>
            <div className={styles.value}>
              {strings.ssnMasked(cardActivationInfo.ssnLast4)}
            </div>
          </div>
          <div className={styles.divider} />
          <div className={styles.row}>
            <div className={styles.label}>{strings.dob}</div>
            <div className={styles.value}>
              {cardActivationInfo.formattedDOB}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
